// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__24bWX","errors":"Errors_errors__18e4D"};